import { BrowserRouter } from "react-router-dom";
import { AppContent } from "./AppContent";

export default function AppRoutes() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}
